<div class="page">
    <div class="container-fluid login">
        <div class="row">
            <div class="col-md-12">
                <div class="box mt40 mb40 static">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="static-content dealer-content">
                                <h2>Bayilik Başvuru Formu</h2>
                                <form [formGroup]="dealerForm">
                                    <div class="contact-widget dealer-form">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <input class="contact-input" placeholder="Firma İsmi / Ünvanı"
                                                        formControlName="company" [disabled]="formValid">
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <input class="contact-input" required placeholder="Yetkili Ad Soyad (*)"
                                                        formControlName="name">
                                                    <div class="text-danger" *ngIf="!nameValid">Ad Soyad bilgisi gerekli.</div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <input class="contact-input" placeholder="Telefon (*)" prefix="+90"
                                                        mask="(000) 000 00 00" formControlName="phone"
                                                        (ngModelChange)="checkPhone()" [disabled]="formValid">
                                                    <div class="text-danger" *ngIf="!phoneValid">Telefon numarasını kontrol ediniz.</div>
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div class="form-group">
                                                    <input class="contact-input" type="email" placeholder="E-Posta (*)"
                                                        formControlName="email" [disabled]="formValid">
                                                    <div class="text-danger" *ngIf="!mailValid">Eposta adresini kontrol ediniz.</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <select class="contact-input" formControlName="province" [disabled]="formValid">
                                                        <option [ngValue]="0">Bayilik Talep Edilen İl*</option>
                                                        <option *ngFor="let c of cityList" [ngValue]="c.Name">{{c.Name}}</option>
                                                    </select>
                                                    <div class="text-danger" *ngIf="!provinceValid">İl seçimi gerekli.</div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <input class="contact-input" type="text" required placeholder="İlçe (*)"
                                                        formControlName="district" [disabled]="formValid">
                                                    <div class="text-danger" *ngIf="!districtValid">İlçe bilgisi gerekli.</div>
                                                </div>
                                            </div>
                                            <div class="col-md-4">
                                                <div class="form-group">
                                                    <input class="contact-input" placeholder="Web Sitesi" type="text"
                                                        formControlName="website" [disabled]="formValid">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group">
                                                    <textarea placeholder="Mesaj" id="Message" name="Message" formControlName="message"
                                                        [disabled]="formValid"></textarea>
                                                </div>
                                            </div>

                                        </div>
                                        <div class="row">
                                            <div class="col-md-12 tac">
                                                <button formmethod="post" class="btn btn-primary btn-l" (click)="onSubmit()"
                                                    *ngIf="!formValid">Gönder</button>
                                            </div>
                                            <div class="col-md-12" *ngIf="formValid">
                                                <div class="contact-success-card">
                                                    <div class="contact-success-icon">✓</div>
                                                    <h2 class="contact-success-title">Başvurunuz Alınmıştır!</h2>
                                                    <p class="contact-success-desc">En kısa sürede sizinle iletişime geçeceğiz.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                                <ngx-loading [show]="loading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
